import { Pipe, PipeTransform } from '@angular/core';
import { ActivityEntityName, EntityLink } from '@jms/model';
import * as Enumerable from 'linq';

@Pipe({
  name: 'displayEntityLink',
  standalone: true
})
export class DisplayEntityLinkPipe implements PipeTransform {

  transform(links: EntityLink[], type: ActivityEntityName): string {

    const name = Enumerable.from(links).firstOrDefault(x => x.type === type)?.name;

    return name;
  }

}
